import { InfoButton, Para, Stack } from '@drycut/ui-components';

import type { CheckoutStepProps } from '../CheckoutStep';

type Props = {
  manual: boolean;
};

export function PaymentHeading({ manual }: Props): CheckoutStepProps['title'] {
  if (!manual) {
    return 'Bezahlung';
  }

  return (
    <Stack direction="row">
      <Para as="span" weight="medium">
        Buchen
      </Para>

      <InfoButton
        title="Buchen"
        text="Rabatte können ausschliesslich bei der Buchung appliziert werden. Mit der Buchung werden die AGB von DRYCUT akzeptiert."
        className="z-20"
      />
    </Stack>
  );
}
